import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './auth'
import Layout from './components/Layout'
import Browse from './pages/Browse'
import Login from './pages/Login'
import Admin from './pages/Admin'
import Account from './pages/Account'
import Home from './pages/Home'
import PublicLink from './pages/PublicLink'
import ShareLinks from './pages/ShareLinks'
import Trash from './pages/Trash'

export default function App() {
  const { user, ready } = useAuth()

  // Share links must work for people with no account, so this route sits ahead
  // of the session check and never waits on it.
  if (location.pathname.startsWith('/s/')) {
    return (
      <Routes>
        <Route path="/s/:token" element={<PublicLink />} />
      </Routes>
    )
  }

  if (!ready) {
    return (
      <div className="boot">
        <div className="spinner" aria-label="불러오는 중" />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        {/* The trailing splat carries the folder path inside the root. */}
        <Route path="/r/:rootId/*" element={<Browse />} />
        <Route path="/links" element={<ShareLinks />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/account" element={<Account />} />
        {user.role === 'admin' && <Route path="/admin/*" element={<Admin />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
